import React, { useEffect, useState } from "react";
import TreeList, { Column, Editing, Selection, SearchPanel as TreeSearch } from "devextreme-react/tree-list";
import FontFa from "../../../../../components/fontFa/fontFa";
import DataGrid, {
  FilterRow,
  HeaderFilter,
  SearchPanel,
  Button as GirdButton,
  Texts,
  RequiredRule,
  EmailRule,
  Paging,
} from "devextreme-react/data-grid";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { Employee, EmployeeService } from "../../../../../services/department-viags/employee-viags.service";
import { CreateNotification } from "../../../../../components/notifier";
import { Icon } from "../../../../../modules/icon";
import { useDepartments } from "../../../../setting/departments/hooks/use-departments";
import DepartmentDescTooltip from "../../../../setting/departments/components/department-desc-tooltip";

export const PublicDepartmentList = (props: any) => {
  const { onClose, isOpen, onConfirmPermission, documentTitle } = props;
  const [selectedEmployee, setSelectedEmployee] = useState<any>([]);
  const [isViewChecked, setIsViewChecked] = useState<any>(false);
  const [isEditChecked, setIsEditChecked] = useState<any>(false);
  const [employeeData, setEmployeeData] = useState<Employee[]>([]);
  const { data: departmentList, isLoading } = useDepartments();
  const [isUpdateEmployee, setIsUpdateEmployee] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState(null as any);
  const [allowUpdate, setAllowUpdate] = useState(false);
  const [isEmployeeLoading, setIsEmployeeLoading] = useState(false);

  const handleNameRender = (e: any) => {
    return (
      <div
        style={{
          cursor: "pointer",
          padding: "4px",
          backgroundColor: selectedDepartment?.id === e.data.id ? "#bae6fd" : "",
        }}
      >
        <span className="mr-1 text-warning">
          {" "}
          <FontFa name="faBuilding" size={"xs"} />
        </span>
        <span style={{ display: "inline-block", marginRight: 4 }}>{e.data.name}</span>
        <DepartmentDescTooltip desc={e.data.infoExtras} />
      </div>
    );
  };

  const getEmployee = async (departmentId: string) => {
    const res = await EmployeeService.getEmployeeListV5(departmentId);
    if (!res) return;
    return res;
  };

  const getIsView = (eEmail: string) => {
    const isView = selectedEmployee.find((e: any) => e.employeeEmail?.toLowerCase() === eEmail);
    return isView?.isView || false;
  };

  const getIsEdit = (eEmail: string) =>
    selectedEmployee.find((e: any) => e.employeeEmail?.toLowerCase() === eEmail)
      ? selectedEmployee.find((e: any) => e.employeeEmail?.toLowerCase() === eEmail).isEdit
      : false;

  const handleCellClick = async (e: any) => {
    setIsEmployeeLoading(true);
    setSelectedDepartment(e?.row?.key);
    const treeList = e?.component;
    const targetRowKey = e?.key;
    treeList.expandRow(targetRowKey);
    const departmentId = e?.row?.key;
    const employeeDepartmentData = await getEmployee(departmentId);
    if (employeeDepartmentData && employeeDepartmentData.length > 0) {
      employeeDepartmentData.forEach((e: any) => {
        e.isView = getIsView(e?.employeeEmail?.toLowerCase());
        e.isEdit = getIsEdit(e?.employeeEmail?.toLowerCase());
      });
      setEmployeeData(employeeDepartmentData);
    } else {
      setEmployeeData([]);
    }
    setIsViewChecked(false);
    setIsEmployeeLoading(false);
  };

  const updateRow = async (row: any) => {
    if (isUpdateEmployee) {
      const { isEdit, isView, acceptUpdate, ...fields } = row.data;
      const res = await EmployeeService.updateEmployee(fields);
      if (res.data) {
        CreateNotification({
          title: "Thành công",
          body: "Đã chỉnh sửa nhân sự thành công có mã " + fields.employeeCode,
          icon: "/icons/success.png",
        });
      } else {
        CreateNotification({ title: "Không thể thêm", body: "Email đã tồn tại", icon: "/icons/warning.png" });
      }
    } else {
      const index = selectedEmployee.findIndex(
        (e: any) => e.employeeEmail?.toLowerCase() === row.data.employeeEmail.toLowerCase(),
      );
      if (index < 0) selectedEmployee.push(row.data);
      else {
        selectedEmployee[index] = { ...row.data };
      }
      setAllowUpdate(true);
    }
  };

  const confirmPermission = () => {
    if (selectedEmployee.length > 0) {
      const newArr = selectedEmployee.map((e: any) => {
        return {
          id: e.employeeCode,
          displayName: e.employeeName,
          jobTitle: e.position,
          surname: e.employeeName,
          PersonType: {
            class: "Person",
            subclass: "OrganizationUser",
          },
          givenName: e.employeeName,
          userPrincipalName: e.employeeEmail?.toLowerCase(),
          departmentId: e.departmentId,
          department: e.departmentName,
          departmentCode: e.departmentCode,
          pDeptCode: e.depList?.at(1)?.name_VN,
          isView: e.isView,
          isEdit: e.isEdit,
        };
      });
      onConfirmPermission(newArr);
    }
    onClose();
    setSelectedDepartment(null);
  };

  const handleEditHeaderCheckboxChange = (e: any, cellInfo: any) => {
    const checked: any = e.target.checked;
    const rowData = cellInfo.component.getDataSource()._items;
    rowData.forEach((row: any) => {
      if (row.isEdit !== checked && row?.employeeEmail && row?.employeeEmail?.toLowerCase().includes("@viags.vn")) {
        row.isEdit = checked;
        const checkedRow = { ...row, isEdit: checked };
        const selectedIndex = selectedEmployee.findIndex(
          (employee: any) => employee.employeeEmail === row.employeeEmail,
        );
        if (selectedIndex > -1) selectedEmployee[selectedIndex] = { ...checkedRow };
        else selectedEmployee.push(checkedRow);
      } else return { ...e };
    });
    setIsEditChecked(checked);
    setEmployeeData(rowData);
  };

  const handleViewHeaderCheckboxChange = (e: any, cellInfo: any) => {
    const checked: any = e.target.checked;
    const rowData = employeeData;
    rowData.forEach((row: any) => {
      if (row.isView !== checked && row?.employeeEmail && row?.employeeEmail?.toLowerCase().includes("@viags.vn")) {
        row.isView = checked;
        const checkedRow = { ...row, isView: checked };
        const selectedIndex = selectedEmployee.findIndex(
          (employee: any) => employee.employeeEmail === row.employeeEmail,
        );
        if (selectedIndex > -1) selectedEmployee[selectedIndex] = { ...checkedRow };
        else selectedEmployee.push(checkedRow);
      } else return { ...e };
    });
    setIsViewChecked(checked);
    setEmployeeData(rowData);
    setAllowUpdate(false);
    setAllowUpdate(true);
  };

  const handleEditClick = () => {
    if (!selectedDepartment) {
      CreateNotification({
        title: "Không thể thêm",
        body: "Anh/Chị vui lòng chọn phòng ban trước",
        icon: "/icons/warning.png",
      });
      return;
    }
    setIsUpdateEmployee(!isUpdateEmployee);
  };

  const addNewRow = async (row: any) => {
    if (!row.data.employeeCode || !row.data.employeeName || !row.data.employeeEmail) {
      row.cancel = true;
      CreateNotification({
        title: "Không thể thêm",
        body: "Anh/Chị vui lòng nhập đầy đủ thông tin",
        icon: "/icons/warning.png",
      });
      return;
    } else if (!row.data.employeeEmail?.includes("@viags.vn")) {
      row.cancel = true;
      CreateNotification({ title: "Không thể thêm", body: "Email không hợp lệ", icon: "/icons/warning.png" });
      return;
    } else {
      const fields = {
        employeeCode: row.data.employeeCode,
        employeeName: row.data.employeeName,
        employeeEmail: row.data.employeeEmail,
        departmentCode: selectedDepartment.code,
        departmentName: selectedDepartment.name,
      };
      const res = await EmployeeService.addEmployee(fields);
      if (res.statusCode === 200) {
        CreateNotification({
          title: "Thêm thành công",
          body: "Thêm thành công nhân viên với mã nhân viên " + res.data,
          icon: "/icons/success.png",
        });
      }
    }
  };

  const removeRow = async (row: any) => {
    const fields = {
      employeeCode: row.data.employeeCode,
    };
    try {
      const res = await EmployeeService.deleteEmployee(fields);
      if (res.data)
        CreateNotification({
          title: "Xóa thành công",
          body: "Xóa thành công nhân sự có mã " + row.data.employeeCode,
          icon: "/icons/success.png",
        });
    } catch (error: any) {
      CreateNotification({ title: "Không thể xóa", body: error.message, icon: "/icons/warning.png" });
      console.log(error);
    }
  };

  const handleTextChange = async (e: any) => {
    const employeeDepartmentData = await getEmployee("1");
    if (employeeDepartmentData && employeeDepartmentData.length > 0) {
      employeeDepartmentData.forEach((e: any) => {
        e.isView = getIsView(e?.employeeEmail?.toLowerCase());
        e.isEdit = getIsEdit(e?.employeeEmail?.toLowerCase());
      });
      setEmployeeData(employeeDepartmentData);
    } else {
      setEmployeeData([]);
    }
  };

  useEffect(() => {
    // setSelectedEmployee([]);
    setEmployeeData([]);
    setSelectedDepartment(null);
    setIsUpdateEmployee(false);
    setIsViewChecked(false);
  }, [isOpen]);

  useEffect(() => {
    setSelectedEmployee([]);
  }, [documentTitle]);

  return (
    <Modal show={isOpen} onHide={onClose} centered size={"xl"} className="" backdrop="static">
      <Modal.Header closeButton>
        <div>
          <Modal.Title>Ban hành tài liệu {documentTitle} tới: </Modal.Title>
          {selectedDepartment && <div>🏢 {selectedDepartment.name}</div>}
        </div>
      </Modal.Header>

      <Modal.Body className="px-4 py-4" style={{ height: "600px" }}>
        {isLoading ? (
          <div className="tableLoading">
            <Icon.Loading />
          </div>
        ) : (
          <Row>
            <Col
              sm="3"
              md="3"
              style={{ maxHeight: "500px", overflow: "hidden", display: "flex", flexDirection: "column" }}
            >
              <TreeList
                id="Folder"
                dataSource={departmentList}
                showRowLines={false}
                showBorders={false}
                columnAutoWidth={true}
                allowColumnReordering={false}
                itemsExpr="viagsDepartmentChild"
                dataStructure="tree"
                expandNodesOnFiltering={false}
                autoExpandAll={false}
                onCellClick={handleCellClick}
                keyExpr="id"
                height="100%" // Ensures it fills the parent container
                style={{ flex: 1, overflow: "auto" }} // Allows internal scrolling
              >
                <Selection mode="single" key={selectedDepartment} />
                <TreeSearch visible={true} placeholder="Nhập tên phòng ban" width={200} />
                <Column
                  dataField="name"
                  caption="Phòng/Ban"
                  key="id"
                  cellRender={handleNameRender}
                  allowReordering={false}
                />
              </TreeList>
            </Col>

            {isEmployeeLoading ? (
              <div className="tableLoading">
                <Icon.Loading />
              </div>
            ) : (
              <Col sm="9" md="9">
                <Button
                  style={{ position: "absolute", top: "4px", left: "24px", zIndex: "9999" }}
                  variant="primary"
                  onClick={() => setEmployeeData(selectedEmployee)}
                >
                  Danh sách đã phân quyền
                </Button>
                <DataGrid
                  id="employees"
                  dataSource={employeeData}
                  showRowLines={true}
                  showBorders={true}
                  columnAutoWidth={true}
                  keyExpr="employeeEmail"
                  className="px-2"
                  noDataText="Anh/Chị chưa chọn phòng ban hoặc phòng ban chưa có nhân sự nào"
                  onRowUpdated={updateRow}
                  onRowInserting={addNewRow}
                  onRowRemoved={removeRow}
                >
                  <Paging defaultPageSize={10} />
                  <HeaderFilter visible={true} />
                  <FilterRow visible={true} applyFilter={true} />
                  <SearchPanel
                    visible={true}
                    placeholder="Nhập tên nhân sự cần tìm"
                    width={500}
                    onTextChange={handleTextChange}
                  />
                  {/* <Toolbar>
                    <Item location="before">
                      <div className="informer">
                        <h2 className="count">state.totalCount</h2>
                      </div>
                    </Item>
                    <Item location="after">
                    </Item>                    
                  </Toolbar> */}
                  <Editing
                    allowAdding={isUpdateEmployee}
                    allowDeleting={(e: any) => e.row.data.acceptUpdate && isUpdateEmployee}
                    allowUpdating={(e: any) =>
                      (e.row.data.employeeEmail &&
                        e.row.data.employeeEmail !== "0" &&
                        e.row.data.employeeEmail.toLowerCase().includes("@viags.vn") &&
                        !isUpdateEmployee) ||
                      (isUpdateEmployee && e.row.data.acceptUpdate)
                    }
                    mode="cell"
                    refreshMode="reshape"
                  >
                    <Texts confirmDeleteMessage="Anh/Chị có muốn xóa nhân sự này" confirmDeleteTitle="Thông báo" />
                  </Editing>

                  <Column
                    dataField="employeeCode"
                    caption="Mã nhân sự"
                    dataType="string"
                    allowEditing={isUpdateEmployee}
                    // width={150}
                    // cellRender={(e) => <p>{e.data.ID + ""}</p>}
                  >
                    <RequiredRule message="Anh/Chị vui lòng nhập mã nhân sự" />
                  </Column>
                  <Column dataField="employeeName" caption="Tên nhân sự" allowEditing={isUpdateEmployee} width={250}>
                    <RequiredRule message="Anh/Chị vui lòng nhập tên nhân sự" />
                  </Column>
                  <Column
                    dataField="employeeEmail"
                    caption="Email"
                    allowEditing={isUpdateEmployee}
                    // width={225}
                    // visible={(e: any) => {return e.data.isUser}}
                  >
                    <RequiredRule message="Anh/Chị vui lòng nhập mã email" />
                    <EmailRule message="Email không hợp lệ" />
                    {/* <CustomRule
                    message= {`Đối với tài khoản dùng chung email bắt đầu với chuỗi kí tự "QLTL_"`}
                  /> */}
                    {/* <PatternRule
                          message="Email address must belong to @viags.vn domain"
                          pattern={/^[a-zA-Z0-9._%+-]+@viags\.vn$/}
                        /> */}
                  </Column>
                  <Column
                    dataField="isView"
                    caption="Quyền xem"
                    dataType="boolean"
                    allowEditing={!isUpdateEmployee}
                    calculateDisplayValue={() => false}
                    width={170}
                    allowHeaderFiltering={false}
                    visible={!isUpdateEmployee}
                    allowSorting={false}
                    headerCellRender={(cellInfo: any) => (
                      <>
                        <span>Quyền view </span>
                        <input
                          type="checkbox"
                          checked={isViewChecked}
                          onChange={(e) => handleViewHeaderCheckboxChange(e, cellInfo)}
                        />
                      </>
                    )}
                  />
                  <Column type="buttons" visible={isUpdateEmployee}>
                    <GirdButton name="edit" icon="edit" hint="Chỉnh sửa nhân sự này" />
                    <GirdButton name="delete" icon="trash" hint="Xóa nhân sự này" />
                  </Column>
                  <Column
                    dataField="isEdit"
                    caption="Quyền chỉnh sửa"
                    dataType="boolean"
                    allowEditing={true}
                    calculateDisplayValue={() => false}
                    width={150}
                    allowHeaderFiltering={false}
                    allowSorting={false}
                    headerCellRender={(cellInfo: any) => (
                      <>
                        <span>Quyền Edit </span>
                        <input
                          type="checkbox"
                          checked={isEditChecked}
                          onChange={(e) => handleEditHeaderCheckboxChange(e, cellInfo)}
                        />
                      </>
                    )}
                  />
                </DataGrid>
                {isUpdateEmployee && (
                  <div>
                    <p className="px-2 py-2 text-danger">
                      *Khi thêm tài khoản dùng chung anh chị vui lòng bắt đầu với chuỗi kí tự "QLTL_Gr"
                    </p>
                  </div>
                )}
              </Col>
            )}
          </Row>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleEditClick} variant={isUpdateEmployee ? "success" : "warning"}>
          {isUpdateEmployee ? "Hoàn tất" : "Chỉnh sửa"}
        </Button>
        <Button onClick={onClose} variant="secondary" hidden={isUpdateEmployee}>
          Hủy
        </Button>
        <Button onClick={confirmPermission} variant={"info"} disabled={!allowUpdate} hidden={isUpdateEmployee}>
          Cập nhật
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
